module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "maintenance"
    }
  }, [_c('h3', [_vm._v("Trwa aktualizacja systemu...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48f3dbb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Maintenance.vue
// module id = 1280
// module chunks = 2